import React from "react";
import LoanData from "./LoanDataView";
import {dateDDMMYY} from "../../utils/formatters/Date";
import {
    amount,
    numberWithComma,
    price,
    rateMultipliedByOneHundred,
    requiredPercentMultipliedOneHundred,
} from "../../utils/formatters/Numbers"
import {RestrictionsService} from "../../service/ptm/RestrictionsService";


export default class LoanDataContainer extends React.Component {
    constructor(props) {
        super(props);

        this.restrictionsService = new RestrictionsService();

        this.getRestrictionsLoan = this.getRestrictionsLoan.bind(this);

        this.getDetailLoanFirstColumn = this.getDetailLoanFirstColumn.bind(this);
        this.getDetailLoanSecondColumn = this.getDetailLoanSecondColumn.bind(this);
        this.getDetailLoanThirdColumn = this.getDetailLoanThirdColumn.bind(this);
        this.getDetailLoanFourthColumn = this.getDetailLoanFourthColumn.bind(this);
        this.is24Hrs = this.is24Hrs.bind(this);
        this.setReward = this.setReward.bind(this);

        this.state = {
            loanId: props.loanId,
            selectedLoan: props.selectedLoan,
            amount: 0,
            detailLoan_1: [],
            detailLoan_2: [],
            detailLoan_3: [],
            detailLoan_4: [],
            restrictions: '',
            reward: props.selectedLoan.premio,
            porcRequeridoVal: props.selectedLoan.porcRequeridoVal,
            porcGarantizadoVal: props.selectedLoan.porcGarantizadoVal,
            isPrecio24Hrs: props.isPrecio24Hrs ? props.isPrecio24Hrs : false,
            isExtension: props.isExtension ? props.isExtension : false,
        };

        this.getRestrictionsLoan(props.loanId);
    }

    getLoan() {
        this.getDetailLoanFirstColumn(this.state.selectedLoan);
        this.getDetailLoanSecondColumn(this.state.selectedLoan);
        this.getDetailLoanThirdColumn(this.state.selectedLoan);
        this.getDetailLoanFourthColumn(this.state.selectedLoan);
        this.props.loading(false);
    }

    is24Hrs(loan) {
        return dateDDMMYY(loan.fecMov) === dateDDMMYY(Date.now()) || this.state.isPrecio24Hrs;
    }

    setReward(reward) {
        let loanData = [
            {name: "Plazo", value: this.state.selectedLoan.plazo},
            {name: "Tasa", value: rateMultipliedByOneHundred(this.state.selectedLoan.tasa)},
            {name: "Sobre Tasa", value: rateMultipliedByOneHundred(this.state.selectedLoan.sobreTasa)},
            {name: "Premio", value: amount(reward)},
            {name: "Aforo", value: this.state.selectedLoan.descrAforo},
        ];

        this.setState({
            detailLoan_2: loanData,
        });
    }

    getDetailLoanFirstColumn(loan) {
        let loanData = [
            {name: "Folio", value: loan.idFolioPrest},
            {name: "Emisora", value: loan.emisora},
            {name: "Títulos", value: numberWithComma(loan.cantPrestamo)},
            {name: "Precio", value: this.is24Hrs(loan) ? price(loan.precio24Hrs) : price(loan.precioVal)},
            {name: "Importe", value: this.is24Hrs(loan) ? amount(loan.importe24Hrs) : amount(loan.importeVal)},
        ];
        this.setState({
            detailLoan_1: loanData,
            titles: loan.cantPrestamo,
            amount: this.is24Hrs(loan) ? loan.importe24Hrs : loan.importeVal,
            price: this.is24Hrs(loan) ? loan.precio24Hrs : loan.precioVal,
        });
    }

    getDetailLoanSecondColumn(loan) {
        let loanData = [
            {name: "Plazo", value: loan.plazo},
            {name: "Tasa", value: rateMultipliedByOneHundred(loan.tasa)},
            {name: "Sobre Tasa", value: rateMultipliedByOneHundred(loan.sobreTasa)},
            {name: "Premio", value: amount(this.state.reward)},
            {name: "Aforo", value: loan.descrAforo},
        ];

        this.setState({
            detailLoan_2: loanData,
        });
    }

    getDetailLoanThirdColumn(loan) {
        let loanData = [
            {name: "Prestamista", value: loan.nomCortoPTM},
            {name: "Cta. Prestamista", value: loan.cuentaPTM},
            {name: "Prestatario", value: loan.nomCortoPTT},
            {name: "Cta. Prestatario", value: loan.cuentaPTT},
            {name: "Estatus", value: loan.statusPV},
        ];
        this.setState({
            detailLoan_3: loanData,
        });
    }

    getDetailLoanFourthColumn(loan) {
        let porcRequerido = this.state.isExtension ? loan.porcRequerido24Hrs : loan.porcRequeridoVal;
        let porcGarantizado = this.state.isExtension ? loan.porcGarantizado24Hrs : loan.porcGarantizadoVal;

        let loanData = [
            {name: "Tipo de Préstamo", value: loan.loanType},
            {name: "Fecha Valor", value: dateDDMMYY(loan.fecMov)},
            {name: "Fecha Vence", value: dateDDMMYY(loan.fecVenc)},
            {
                name: "% Requerido",
                value: porcRequerido === null ? "" : requiredPercentMultipliedOneHundred(porcRequerido)
            },
            {
                name: "% Garantizado",
                value: porcGarantizado === null ? "" : requiredPercentMultipliedOneHundred(porcGarantizado)
            },
        ];
        this.setState({
            detailLoan_4: loanData,
        });
    }

    getRestrictionsLoan(loanId) {
        this.restrictionsService.getRestrictionsLoan(loanId).then(response => {
            this.setState({
                restrictions: response,
            })
        });
    }

    render() {
        return <LoanData
            restrictions={this.state.restrictions}
            detailLoan_1={this.state.detailLoan_1}
            detailLoan_2={this.state.detailLoan_2}
            detailLoan_3={this.state.detailLoan_3}
            detailLoan_4={this.state.detailLoan_4}
        />
    }
};